import React, { useRef, useEffect, useState } from 'react'
import './Anchor.scss'

function Anchor({ data, refs }) {
  refs[data.anchor] = useRef()
  const [idReady, setIdReady] = useState(false)
  const HEADER_OFFSET = 160

  useEffect(() => {
    const selected = location.hash.replace('#', '').split('?')[0]
    const isTarget = selected === data.anchor

    if (!isTarget) {
      setIdReady(true)
      return
    }

    let stopped = false
    let intervalId = null

    const stopScrolling = () => {
      stopped = true
      if (intervalId) clearInterval(intervalId)
      setIdReady(true)
      window.removeEventListener('wheel', stopScrolling)
      window.removeEventListener('touchmove', stopScrolling)
    }

    window.addEventListener('wheel', stopScrolling, { once: true })
    window.addEventListener('touchmove', stopScrolling, { once: true })

    const scrollToAnchor = () => {
      const el = refs[data.anchor]?.current
      if (!el) return
      const rect = el.getBoundingClientRect()
      const targetTop = rect.top + window.pageYOffset - HEADER_OFFSET
      window.scrollTo({ top: targetTop, behavior: 'smooth' })
    }

    // Tenta scroll a cada 500ms até estabilizar
    let lastTop = null
    let stableCount = 0

    const startTimer = setTimeout(() => {
      scrollToAnchor()

      intervalId = setInterval(() => {
        if (stopped) return
        const el = refs[data.anchor]?.current
        if (!el) return

        const rect = el.getBoundingClientRect()
        const currentTop = rect.top + window.pageYOffset

        if (lastTop !== null && Math.abs(currentTop - lastTop) < 3) {
          stableCount++
          if (stableCount >= 3) {
            // Posição estabilizou - faz scroll final e para
            scrollToAnchor()
            stopScrolling()
            return
          }
        } else {
          stableCount = 0
          scrollToAnchor()
        }
        lastTop = currentTop
      }, 500)
    }, 800)

    // Timeout máximo
    const maxTimer = setTimeout(() => {
      if (!stopped) {
        scrollToAnchor()
        stopScrolling()
      }
    }, 10000)

    return () => {
      clearTimeout(startTimer)
      clearTimeout(maxTimer)
      stopped = true
      if (intervalId) clearInterval(intervalId)
      window.removeEventListener('wheel', stopScrolling)
      window.removeEventListener('touchmove', stopScrolling)
    }
  }, [])

  return <a ref={refs[data.anchor]} id={idReady ? data.anchor : undefined} className="anchor-target" />
}

export default Anchor
